var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import PartnerOfferBanner from './PartnerOfferBanner';
import WelcomeBanner from './WelcomeBanner';
import ErrorBoundary from '../../../Components/ComponentErrorBoundary';
import { getGlobalState } from '../../../Utils/GlobalState';
const user = getGlobalState('user');
const DashboardBanners = ({ showWelcomeBanner = false, welcomeBannerText = null, onboardingPartner = null }) => {
    const [partnersPackages, setPartnersPackages] = useState(null);
    useEffect(() => {
        resolveBannersVisibility();
    }, []);
    return (_jsxs(_Fragment, { children: [showWelcomeBanner && _jsx(ErrorBoundary, { children: _jsx(WelcomeBanner, { text: welcomeBannerText, onboardingPartner: onboardingPartner }) }), partnersPackages != null && _jsx(ErrorBoundary, { children: _jsx(PartnerOfferBanner, { partnersPackages: partnersPackages, userId: user === null || user === void 0 ? void 0 : user.id }) })] }));
    function resolveBannersVisibility() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const userPartners = (_a = user === null || user === void 0 ? void 0 : user.partners) !== null && _a !== void 0 ? _a : [];
            const promises = [];
            userPartners.forEach((partner) => promises.push(axios.get(`/api/package/${partner.id}`)));
            const packagesData = yield Promise.all(promises);
            if (packagesData != null && packagesData.length > 0) {
                const isAnyPackageActive = packagesData.some((partnerPackage) => partnerPackage.data.is_package && partnerPackage.data.partner_info.package_activated);
                if (isAnyPackageActive) {
                    setPartnersPackages(packagesData.map(({ data }) => data));
                }
            }
        });
    }
};
DashboardBanners.propTypes = {
    showWelcomeBanner: PropTypes.bool,
    welcomeBannerText: PropTypes.string,
    onboardingPartner: PropTypes.object
};
export default DashboardBanners;
